<template>
    <div :class="widgetData.container">
        <div class="row d-flex justify-content-center" v-if="widgetData.description">
            <div class="col-12 col-md-10 col-lg-7">
                <div class="section-title">
                    <div v-html="widgetData.description"></div>
                </div>
            </div>
        </div>
        <div class="row d-flex justify-content-center">
            <div class="col-12 col-md-10 col-lg-7">
              <ul class="list-group">
                <li v-for="file in content" class="list-group-item">
                  <div class="d-flex">
                    <div class="icon-doc w-25"><TyIcon icon="ty-file-2" width="1rem" class="me-2"/></div>
                    <div class="title-doc w-50"><p class="title d-inline-block mb-0">{{ file.title }}</p></div>
                    <div class="down-doc w-25 text-center text-lg-end"><a class="btn btn-light btn-xs" :title="file.downloadFileName()"
                                             :download="file.downloadFileName()" target="_blank" :href="file.getTyrionSrc()">{{ $t('download') }}</a></div>
                  </div>
                </li>
              </ul>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {PropType} from "vue";
import {PageDataHolderFetchedWidget} from "../../../../lib/interfaces/model/PageDataHolderFetchedWidget";
import {useWidget} from "../../../../composables/widget/file_list";

const props = defineProps({
  widget: Object as PropType<PageDataHolderFetchedWidget>
});

const {widgetData, content} = useWidget(props.widget);
</script>
